import React from 'react';
import { cm } from 'src/utils/classNames';
import { WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName {
	loading?: boolean;
}

const SkeletonValuePlaceholder = ({ loading, className }: Props) => {
	return (
		<div
			className={cm(
				'rounded-xs bg-input-border',
				loading && 'animate-pulse',
				className
			)}
		/>
	);
};

export default SkeletonValuePlaceholder;
